<template>
    <v-image
        v-if="src"
        :config="{ ...config , ...imageConfig}"
        @dragstart="(e) => $emit('dragstart', e)"
        @dragend="(e) => $emit('dragend', e)"
        @dblclick="(e) => $emit('dblclick', e)"
        @click="(e) => $emit('click', e)"
    />
</template>

<script>
export default {
    props: {
        config: {
            type: Object,
            default: () => ({}),
        },
        src: {
            type: String,
            required: true,
        },
        isDragging: {
            type: Boolean,
            default: false,
        },
    },
    emits: ['dragstart', 'dragend', 'dblclick', 'click'],
    data() {
        return {
            stageSize: {
                width: window.innerWidth,
                height: window.innerHeight,
            },
            image: null,
        };
    },

    computed: {
        imageConfig() {
            return {
                image: this.image,
                opacity: this.opacity,
            };
        },

        opacity() {
            if (this.isDragging) return 0.5;

            return 1;
        },
    },
    watch: {
        src: {
            handler(newSrc, oldSrc) {
                if (newSrc !== oldSrc) {
                    this.loadImageFromUrl();
                }
            },
        },
    },
    created() {
        if (this.image) return;
        if (this.src) this.loadImageFromUrl();
    },

    methods: {
        loadImageFromUrl(src = this.src) {
            const image = new window.Image();

            image.src = src;

            image.onload = () => {
            // set image only when it is loaded
                this.image = image;
            };
        },

    },
};
</script>
